export class TipoVariable {
	_id: string;
	descripcion: string;
	tipo: string;
	estado: boolean;
	rangoDesde: Number;
	rangoHasta: Number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoVariable/tipoVariable.ts